"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M11.493 27.963a.216.216 0 0 0-.283-.268c-.735.287-1.852.613-2.335.131-1.525-1.525 1.486-7.762 6.49-12.766S26.666 7.244 28.124 8.7a1.088 1.088 0 0 1 .252 1.011.219.219 0 0 0 .281.249 9.043 9.043 0 0 1 1.5-.326.42.42 0 0 0 .367-.379 2.246 2.246 0 0 0-.5-1.895L30 7.347v-.006A15.952 15.952 0 1 0 7.156 29.58a.84.84 0 0 0 .125.1l.01.011a2.085 2.085 0 0 0 1.532.53 6.5 6.5 0 0 0 2.014-.4.454.454 0 0 0 .3-.361 11.375 11.375 0 0 1 .356-1.497z" }),
  React.createElement("path", { d: "M33.5 14.729c-.293-1.77-.94-2.959-2.509-2.959-2.69 0-7.007 2.72-11 6.928-4.737 5-7.467 10.4-6.638 13.144a2.741 2.741 0 0 0 2.458 1.887 14.376 14.376 0 0 0 2.217.172 14.944 14.944 0 0 0 11-4.744A15.959 15.959 0 0 0 33.5 14.729z" })
);

